import React from 'react';
import PropTypes from 'prop-types';
import { FileInput, HeaderTitle, Label } from '@atlas/ui';
import Field from 'common/Form/Field';

const FileField = ({ field, onChange = () => {} }) => {
  const { label, disabled, name, errors } = field;

  return (
    <div className="form-upload-file-container">
      <HeaderTitle className="sub-text block-medium">
        <span className="header-title__name">2.&nbsp;</span>
        <Label className="header-title__name" message="add_document" />
      </HeaderTitle>
      <Field options={field}>
        {label && <Label message={label} />}

        <FileInput disabled={disabled} onChange={onChange} name={name} errors={errors} />
      </Field>
    </div>
  );
};

FileField.propTypes = {
  field: PropTypes.shape({
    touched: PropTypes.bool,
    errors: PropTypes.array,
    warnings: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    withTranslate: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func,
};

export default FileField;
